export const initFAQ = () => {
    document.querySelectorAll('.nodetype-element--jvmtech-site-content-faqcollection-viewer').forEach(container => {
        const categories = container.querySelectorAll('.c-faq-filter .c-button');
        const sections = container.querySelectorAll('.category-element, .c-faq-container');

        categories.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();

                const category = button.dataset.target ?? '';

                categories.forEach(elem => elem.classList.toggle('active', elem.dataset.category === category));
                button.classList.add('active');

                sections.forEach(elem =>
                    elem
                        .closest('.nodetype-element--jvmtech-site-content-faqcollection-reference')
                        .classList.toggle('hidden', category !== '' && elem.dataset.category !== category)
                );
            });
        });
    });
};
